import { useState } from "react";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import GetIcon from "../../../utils/Icon";
import Tabs from "../../../Components/Tabs";
import ApiResponseBox from "../../../Components/ApiResponseBox";
import { usePostWmsSettingCreationMutation } from "../../../store/api/settingapi";
import { useNavigate } from "react-router-dom";

const WmsSettingForm = () => {
  const nvg = useNavigate();
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error");
  const [showError, setShowError] = useState(false);
  const [cartBinOptions, setCartBinOptions] = useState([]);
  const [CreatSetting] = usePostWmsSettingCreationMutation();
  const [BulkcartBinOptions, setBulkCartBinOptions] = useState([]);
  const [AssemblyBinOptions, setAssemblyBinOptions] = useState([]);
 

  const [formData, setFormData] = useState({
    enable_asn: false,
    warehouse_abbr: false,
    packingSlipRequired: false,
    allowPicklistCreation: false,
    gateEntry: false,
    link_company:'',
    asn_bin:'',
    default_assembly_bin:'',
    defaultPurchaseBin: '',
    defaultRejectedBin: '',
    defaultPurchaseReturn: '',
    defaultSalesReturn: '',
    defaultMfgFromBin: '',
    defaultMfgToBin: '',
    defaultRGPShipment: '',
    defaultRGPReceipt: '',
    b2bBin: '',
    bulkOrderBin: '',
    assembly_pick_warehouse:'',
    serialNoSetup: '',

  });

  const [fieldErrors, setFieldErrors] = useState({
    tab1: {},
    tab2: {}
  });


  const handleInputChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));

    if (fieldErrors.tab1[fieldName] || fieldErrors.tab2[fieldName]) {
      setFieldErrors(prev => {
        const tab = fieldName in prev.tab1 ? 'tab1' : 'tab2';
        return {
          ...prev,
          [tab]: {
            ...prev[tab],
            [fieldName]: false
          }
        };
      });
    }
  };

  const validateForm = () => {
  const newErrors = {
    tab1: {},
    tab2: {}
  };

  let isValid = true;

  // Validate Tab1 fields
  if (!formData.link_company) {
    newErrors.tab1.link_company = 'Link Company is required';
    isValid = false;
  }
  if (!formData.asn_bin) {
    newErrors.tab1.asn_bin = 'ASN Bin is required';
    isValid = false;
  }
  if (!formData.default_assembly_bin) {
    newErrors.tab1.default_assembly_bin = 'Default Assembly Bin is required';
    isValid = false;
  }
  if (!formData.defaultPurchaseBin) {
    newErrors.tab1.defaultPurchaseBin = 'Default Purchase Bin is required';
    isValid = false;
  }
  if (!formData.defaultRejectedBin) {
    newErrors.tab1.defaultRejectedBin = 'Default Rejected Bin is required';
    isValid = false;
  }
  if (!formData.defaultPurchaseReturn) {
    newErrors.tab1.defaultPurchaseReturn = 'Default Purchase Return is required';
    isValid = false;
  }
  if (!formData.defaultSalesReturn) {
    newErrors.tab1.defaultSalesReturn = 'Default Sales Return is required';
    isValid = false;
  }
  if (!formData.defaultMfgFromBin) {
    newErrors.tab1.defaultMfgFromBin = 'Default MFG From Bin is required';
    isValid = false;
  }
  if (!formData.defaultMfgToBin) {
    newErrors.tab1.defaultMfgToBin = 'Default MFG To Bin is required';
    isValid = false;
  }
  if (!formData.defaultRGPShipment) {
    newErrors.tab1.defaultRGPShipment = 'Default RGP Shipment is required';
    isValid = false;
  }
  if (!formData.defaultRGPReceipt) {
    newErrors.tab1.defaultRGPReceipt = 'Default RGP Receipt is required';
    isValid = false;
  }
  if (!formData.serialNoSetup) {
    newErrors.tab1.serialNoSetup = 'Serial No Setup is required';
    isValid = false;
  }
  if (cartBinOptions.length === 0) {
    newErrors.tab1.cartBinOptions = 'B2B Bin is required';
    isValid = false;
  }
  if (BulkcartBinOptions.length === 0) {
    newErrors.tab1.BulkcartBinOptions = 'Bulk Order Bin is required';
    isValid = false;
  }
  if (AssemblyBinOptions.length === 0) {
    newErrors.tab1.AssemblyBinOptions = 'Assembly Pick Warehouse is required';
    isValid = false;
  }

  // Validate Tab2 fields if needed
  // Add similar validations for Tab2 fields here

  setFieldErrors(newErrors);
  return isValid;
};

  const saveData = async () => {
    if (!validateForm()) {
      setError('Please fill all required fields');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      const payload = {
        enable_asn:formData.enable_asn == true ? 1 : 0,
        warehouse_abbr:formData.warehouse_abbr == true ? 1 : 0,
        gate_entry: formData.gateEntry == true ? 1 : 0,
        packing_slip_required: formData.packingSlipRequired == true ? 1 : 0,
        allow_creation_of_picklist_in_stock_shortage: formData.allowPicklistCreation == true ? 1 : 0,
        link_company: formData.link_company,
        asn_bin: formData.asn_bin,
        default_assembly_bin: formData.default_assembly_bin,
        default_purchase_bin: formData.defaultPurchaseBin,
        default_rejected_bin: formData.defaultRejectedBin,
        default_purchaes_return: formData.defaultPurchaseReturn,
        default_sales_return: formData.defaultSalesReturn,
        cart_bin: cartBinOptions.map(warehouseName => ({
          warehouse: warehouseName
        })),
        bulk_order_bin: BulkcartBinOptions.map(warehouseName => ({
          warehouse: warehouseName
        })),
        assembly_pick_warehouse: AssemblyBinOptions.map(warehouseName => ({
          warehouse: warehouseName
        })),
        default_mfg_from_bin: formData.defaultMfgFromBin,
        default_mfg_to_bin: formData.defaultMfgToBin,
        default_rgp_shipment: formData.defaultRGPShipment,
        default_rgp_receipt: formData.defaultRGPReceipt,
        serial_no_setup: formData.serialNoSetup,
      }

      const response = await CreatSetting(payload).unwrap();
      console.log("check api respons eis here bbbb", response);
      setError('Settings saved successfully');
      setptype('Success');
      setShowError(true);
      setTimeout(() => {
        nvg('/setting/');
      }, 1000);
    } catch (err) {
  
      console.error('Error saving settings: 1', err);
      console.error('Error saving settings: 2', err.data);
      console.error('Error saving settings: 3', err.data._server_messages);
    //  if(err?.data?.exception){
    //     message = err.data.exception.replace('frappe.exceptions.ValidationError: ', '');
    //     message = message.replace(/<[^>]*>/g, '');
    //   }
      setError('Error saving settings');
      setptype('Error');
      setShowError(true);
    }
  };

  return (
    <>
      <Tabs />
      <div className="d-flex justify-content-between px-1" style={{ background: "#fcfdfe" }}>
        <div className="d-flex align-items-center customizewidth">
          <p className="m-0 breadcrumb-item">Setting</p>
          <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }}>
            WMS Settings
          </a>
        </div>
        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>
          <p
            style={{ textDecoration: "none", display: "flex" }}
            className="custom-btn-00989 m-0"
            onClick={saveData}
          >
            <GetIcon iconName="LuFilePlus2" size={12} /> &nbsp;
            Save
          </p>
        </div>
      </div>
      <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
        <div className="d-flex justify-content-between align-items-end ">
          <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
              <a className="removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" href="javascript:void(0);">
                General Details <GetIcon iconName="MdKeyboardArrowDown" size={15} />
              </a>
            </li>
          </ul>
          <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
            <span style={{ position: 'relative', top: '-1px' }}>
              <GetIcon iconName="CgAttachment" size={12} />
            </span>
            <span className=" fw-semibold" style={{ color: "#391F84" }}>
              Attachments
            </span>
          </div>
        </div>
      </div>
      <div className="py-2" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="row d-flex justify-content-between">
          <div className="col-12" >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab1
                formData={formData}
                handleChange={handleInputChange}
                errors={fieldErrors.tab1}
                cartBinOptions={cartBinOptions}
                setCartBinOptions={setCartBinOptions}
                BulkcartBinOptions={BulkcartBinOptions}
                setBulkCartBinOptions={setBulkCartBinOptions}
                setAssemblyBinOptions={setAssemblyBinOptions}
                AssemblyBinOptions={AssemblyBinOptions}
              />

              <Tab2
                formData={formData}
                handleChange={handleInputChange}
                errors={fieldErrors.tab1}
              />
            </div>
          </div>
        </div>
      </div>
      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </>
  );
};

export default WmsSettingForm;